/**
 * Generates a descriptive title for a new reflection thread
 * based on the time of day and date.
 *
 * Examples: "Morning Reflection - Mar 30", "Evening Reflection - Mar 28"
 */
export function generateReflectionTitle(date: Date = new Date()): string {
  const hour = date.getHours();
  let period: string;
  if (hour >= 5 && hour < 12) period = 'Morning';
  else if (hour >= 12 && hour < 17) period = 'Afternoon';
  else if (hour >= 17 && hour < 21) period = 'Evening';
  else period = 'Night';

  const dateStr = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  return `${period} Reflection - ${dateStr}`;
}
